module.exports = __webpack_public_path__ + "static/img/6.5d77f7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/6.png
// module id = kKZD
// module chunks = 0